import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { initObservability } from '@brokerportal/common/observability';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_VERSION } from './environments/version';

if (environment.type === 'prod') {
  enableProdMode();
}

initObservability(environment, APP_VERSION);

platformBrowserDynamic().bootstrapModule(AppModule);
